// extracted by mini-css-extract-plugin
export default {"sideNav":"Main1099Layout_sideNav__Riw2e"};